import { MessageCircle, Instagram } from "lucide-react";
import { useSite } from "@/lib/site";

export const WaButton = ({ label, text, variant = "gold", className = "", testId, dark = false }) => {
  const { wa } = useSite();
  const cls = variant === "gold" ? "btn-gold" : `btn-ghost ${dark ? "on-dark" : ""}`;
  return (
    <a href={wa(text)} target="_blank" rel="noopener noreferrer" className={`${cls} ${className}`} data-testid={testId}>
      <MessageCircle className="h-4 w-4" strokeWidth={1.8} />
      <span>{label}</span>
    </a>
  );
};

export const InstaButton = ({ className = "", testId, dark = false, iconOnly = false }) => {
  const { content } = useSite();
  const handle = content?.contacts?.instagram || "dari_event.kg";
  return (
    <a
      href={`https://www.instagram.com/${handle}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Instagram"
      className={`btn-ghost ${dark ? "on-dark" : ""} ${iconOnly ? "!h-11 !w-11 justify-center !p-0" : ""} ${className}`}
      data-testid={testId}
    >
      <Instagram className="h-4 w-4" strokeWidth={1.8} />
      {!iconOnly && <span>Instagram</span>}
    </a>
  );
};

export const SocialButtons = ({ label, text, className = "", testPrefix, dark = false }) => (
  <div className={`flex flex-wrap items-center gap-3 ${className}`}>
    <WaButton label={label} text={text} testId={`${testPrefix}-whatsapp-btn`} />
    <InstaButton dark={dark} testId={`${testPrefix}-instagram-btn`} />
  </div>
);
